module.exports = __webpack_public_path__ + "static/media/userAvatarBlue.24d38a51.svg";